// KpiCard — eyebrow label, large value, delta chip, sparkline.

import type { ReactNode } from "react";
import { cn } from "@/lib/cn";
import { Sparkline } from "./Sparkline";

export interface KpiCardProps {
  eyebrow?: string;
  label: string;
  value: ReactNode;
  delta?: string;
  deltaTone?: "ok" | "warn" | "error" | "info";
  sparklineValues?: number[];
  tone?: "default" | "primary" | "secondary" | "tertiary";
  icon?: ReactNode;
  className?: string;
}

const SPARK_COLOR: Record<NonNullable<KpiCardProps["tone"]>, string> = {
  default: "var(--md-primary)",
  primary: "var(--md-primary)",
  secondary: "var(--md-secondary)",
  tertiary: "var(--md-tertiary)",
};

export function KpiCard({
  eyebrow,
  label,
  value,
  delta,
  deltaTone,
  sparklineValues,
  tone = "default",
  icon,
  className,
}: KpiCardProps) {
  return (
    <article className={cn("lex-kpi", className)} data-tone={tone === "default" ? undefined : tone}>
      <header className="lex-kpi__head">
        <div className="lex-kpi__labels">
          {eyebrow ? <span className="lex-kpi__eyebrow">{eyebrow}</span> : null}
          <span className="lex-kpi__label">{label}</span>
        </div>
        {icon ? <span className="lex-kpi__icon" aria-hidden="true">{icon}</span> : null}
      </header>
      <div className="lex-kpi__value" style={{ fontVariantNumeric: "tabular-nums" }}>{value}</div>
      <footer className="lex-kpi__foot">
        {delta ? <span className="lex-kpi__delta" data-tone={deltaTone === "ok" ? undefined : deltaTone}>{delta}</span> : <span />}
        {sparklineValues?.length ? <Sparkline values={sparklineValues} color={SPARK_COLOR[tone]} width={88} height={28} /> : null}
      </footer>
    </article>
  );
}

export default KpiCard;
